import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import './faq.css';
import HeaderSection from '../../../components/layout/header';
import { CONFIG } from '../../../shared/constants/common';

const ModernFAQ = ({ history }) => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (faqId) => {
    if (openFaq === faqId) {
      setOpenFaq(null);
    } else {
      setOpenFaq(faqId);
    }
  };

  // Scroll to hash section on mount or hash change
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Remove the # symbol
      const id = hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          // Use scrollIntoView which respects CSS scroll-margin-top
          // This ensures the title is visible when scrolling to the section
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 300);
    }
  }, [history.location.hash]);

  return (
    <div className={`modern-faq-page`}>
      <HeaderSection
        type="text"
        title="FAQ"
      />

      {/* Main Content */}
      <main className="modern-faq-main">
        <div className="">

          <div className="modern-faq-section">
            <div className="modern-faq-header-card">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">General Questions</h2>
                </div>
              </div>
            </div>


            <div className="modern-faq-accordion">
              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 1 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(1)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is Juicy House?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 1 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 1 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Juicy House is a tool designed to help content creators connect with their audience on a per-
                      sonal, authentic level. It’s more than just a place to share content, it’s a space built to empower
                      creators and give them full control over their earnings and brand.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 2 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(2)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How is Juicy House different?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 2 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 2 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Juicy House goes far beyond traditional content platforms offering a complete suite of tools and
                      resources designed to help creators grow, market, and elevate their brand. Here’s what makes
                      us different:
                    </p>
                    <ul>
                      <li><b>100% Payout:</b> At Juicy House, we know creating high-quality content takes time, effort,
                        and creativity, and we believe creators should be fully rewarded for their work. That’s
                        why we give creators 100% of their earnings across all features with no commissions,
                        hidden fees, and clear cash-out options. Withdrawals under $100 are free while cash
                        outs over $100 incur a flat $15 fee to cover ACH and cryptocurrency transfer costs. You
                        put in the work to create exceptional content so you deserve to keep every dollar you
                        earn.</li>

                      <li>
                        <b>Reach & Exposure:</b> Unlike other platforms that rely solely on creators to drive traffic,
                        Juicy House actively markets itself outside the platform to bring in new users and expand

                        your audience. Our system combines in-platform discovery with external marketing ef-
                        forts, connecting your content to people who match your niche and interests. This

                        means your work reaches both your existing audience and new viewers discovering Juicy
                        House for the first time, helping you grow your brand faster and more effectively.
                      </li>

                      <li>
                        <b>Personalized Discovery:</b> Our dynamic algorithm helps viewers discover content that
                        matches their interests, adapting over time based on what each subscriber engages with

                        most. Every Discovery page is personalized, giving each subscriber a unique set of rec-
                        ommendations. When a subscriber tips, subscribes, chats, or purchases content, the al-
                        gorithm identifies the creators and content they engage with and highlights similar or

                        relevant creators in their recommendations and on the Discover page. The more users
                        interact with content or profiles similar to yours, the more likely your profile will appear
                        to that targeted audience, creating a personalized experience for viewers while boosting
                        your visibility.
                      </li>

                      <li>
                        <b>Voice & Video Calls:</b> Users can connect with their favorite creators through voice and
                        video calls that ring just like a regular phone. Creators have full control, including setting
                        a minimum call time, charging by the minute, or offering a flat rate for longer sessions.
                      </li>

                      <li>
                        <b>Powerful Alerts:</b> Users are notified both on and off the platform when you offer a dis-
                        count or free trial to expired subscribers. This helps you re-engage your audience, drive

                        more traffic to your content, and maximize conversions by reaching the right users at the
                        right time.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 3 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(3)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How is Juicy House able to pay creators 100%?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 3 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 3 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Juicy House is designed to cover all platform and processing costs behind the scenes so creators
                      receive every dollar they earn from subscriptions, tips, calls, and content. This ensures you get
                      paid in full while we handle the operations and support.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 4 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(4)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why should I verify my email?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 4 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 4 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      A verified email address helps Juicy House confirm that you are the owner of the email linked to

                      your account. Once verified, you’ll receive important notifications and updates from the plat-
                      form. Email verification also ensures your address was entered correctly and makes it easy to

                      recover your account if you ever forget your password.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 5 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(5)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why should I enter my phone number?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 5 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 5 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Phone number verification is optional, but highly recommended. Verifying your number con-
                      firms that you’re the legitimate owner of the number linked to your account and helps speed up

                      the account verification process. Once verified, you will receive important notifications and up-
                      dates via SMS, which can be managed in the Notifications section under Menu. Phone verifica-
                      tion also makes it easier to recover your account if needed.
                    </p>
                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 6 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(6)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How can I change my notification settings?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 6 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 6 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Log in to your account, go to the menu, and select notifications to turn alerts on or off. For
                      added security, users cannot change their email after creating an account.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 7 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(7)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is the pinned message on my profile?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 7 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 7 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      The pinned message is a short, eye-catching description featured below your bio on your pro-
                      file. It’s your chance to spotlight what makes you unique, promote exclusive content, or share a

                      call-to-action, instantly engaging subscribers and drawing them into your world.
                    </p>
                    <p className="modern-faq-answer-text">
                      If you do not include any text within your pinned message, the pinned message tile will be au-
                      tomatically hidden from your profile.
                    </p>
                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 8 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(8)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I am having trouble logging in with the correct email and password. What should I do?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 8 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 8 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Using VPN services may cause your account to be flagged as suspicious. Please make sure
                      that you do not have a VPN or similar services on when logging into your account. If you are
                      still having trouble logging in please contact our support team at <a href="mailto: support@juicyhouse.com">support@juicyhouse.com</a>.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 9 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(9)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What if I don’t accept the Terms of Service?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 9 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 9 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If you do not agree with our Terms you should remove your content, stop using our services
                      or refrain from making an account.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 10 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(10)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I delete my account?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 10 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 10 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>
                        Log in to your account, go to the menu, select account and then delete account, and fol-
                        low the on-screen instructions. You will be asked to manually type “DELETE” to confirm

                        your decision.
                      </li>
                      <li>
                        If you are a content creator with active subscriptions, your account will be deleted once
                        the last subscription expires. During this period, no new subscriptions can be added.
                      </li>
                    </ul>
                    <p className="modern-faq-answer-text">
                      <b>Important:</b> Any active subscription will be lost and will never automatically renew. Once delet-
                      ed, your account will not be able to be restored and you will have to create a new one. You will

                      receive an email confirmation upon the successful deletion of your account.
                    </p>
                  </div>
                </div>
              </div>





              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 11 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(11)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Who can use Juicy House?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 11 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 11 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">To register as a user:</p>
                    <ul>
                      <li>You must be at least 18 years old and will be required to confirm your age.</li>
                      <li>If the laws of your country or state/province set a higher minimum age for entering into
                        a contract, you must meet that age requirement to use Juicy House.</li>
                      <li>You must be legally allowed in your location to join Juicy House, view any content, and
                        use all features of the platform.</li>
                      <li>You must not be a convicted sex offender.</li>
                    </ul>
                    <p className="modern-faq-answer-text">If you do not meet the above requirements, you must not access or use Juicy House.</p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 12 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(12)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Reporting an account</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 12 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 12 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">To report an account, visit the creator’s profile, tap the three dots in the upper-right corner of
                      their header image, and select “Report.” Choose the option that best describes the issue. If the
                      account is impersonating another creator or violating our Terms of Service, it will be reviewed
                      and removed accordingly.</p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 13 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(13)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Reporting a post</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 13 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 13 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">To report a specific post, tap the three dots in the bottom-right corner, select “Report,” and
                      choose the appropriate reason. Posts found to violate our Terms of Service will be removed, and
                      the creator’s account will receive a recorded offense.</p>

                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 14 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(14)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a creator — what happens if I receive several reports?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 14 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 14 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">The Juicy House moderation team manually reviews all reported content and profiles to ensure
                      compliance with our Terms of Service. If a violation is confirmed, the account will receive a
                      marked offense. Accumulating nine offenses results in an account ban.</p>
                    <p className="modern-faq-answer-text">You may appeal a ban within 30 days of its initiation. However, if your account is reinstated and

                      found to violate our Terms of Service again, it may be permanently banned without further re-
                      view. In some cases, certain reports may trigger an immediate suspension while a secondary, in-
                      depth review of your account is conducted.</p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 15 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(15)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Do you review all posted content?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 15 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 15 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Yes! All content on Juicy House is reviewed to ensure compliance with our Terms of Service.

                      Content found in violation may be removed, and repeated violations can result in marked of-
                      fenses, temporary suspension, or permanent account removal.</p>


                  </div>
                </div>
              </div>






              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 16 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(16)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What to do if you suspect your account is being accessed by someone else</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 16 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 16 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>If you suspect your account has been compromised, please login and attempt to change
                        your password immediately.</li>
                      <li>If you are unable to login to your account, tap forgot password on the login page. If you
                        still are unable to login and access your account, please contact <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a> with the email you signed up with for assistance.</li>
                    </ul>


                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 17 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(17)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What type of ID is needed for verification?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 17 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 17 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Verification requires a current government issued photo ID, such as a passport or driver’s li-
                      cense. Make sure all information is clearly visible and the credentials on your ID matches the

                      details you entered on the signup form (e.g., name and birthdate). The photo must be unedited
                      and show the entire ID. Our system uses facial recognition to match your face with the photo on
                      your ID. Approval typically takes up to 30 minutes.</p>
                    <p className="modern-faq-answer-text">If your submission is denied but all information is correct, please contact our team for a manual
                      review at <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a>.</p>


                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 18 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(18)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Can I use Juicy House from my country?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 18 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 18 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">We accept content creators from all regions and countries.</p>


                  </div>
                </div>
              </div>





            </div>



            <div className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Trending Content, Profiles & Featured Creators</h2>
                </div>
              </div>
            </div>



            <div className="modern-faq-accordion">


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 19 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(19)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What does it mean when a creator is featured?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 19 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 19 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Featured creators are selected by our platform’s algorithm based on specific criteria, boosting
                      their visibility. Our featured creator algorithm refreshes monthly, spotlighting new creators to
                      help you discover fresh profiles you may not have encountered yet.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 20 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(20)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What does it mean if a profile is listed as Trending on the Discovery page?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 20 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 20 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Trending profiles highlight creators with a surge in content and subscription purchases over a
                      short period, showcasing the platform's most popular creators right now. This feature helps you
                      discover in-demand content and up-and-coming creators gaining traction. The trending section
                      displays the top 10 profiles and refreshes weekly, giving new creators an opportunity to stand
                      out and keeping the spotlight on fresh talent.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 21 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(21)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What does the fire icon mean on a locked post or profile?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 21 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 21 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      The fire icon highlights popular content or profiles with a spike in user purchases over a short

                      period. It helps you quickly find the most popular content and creators currently capturing at-
                      tention on the platform.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 22 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(22)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">When browsing all profiles, what does the fire icon on a profile mean?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 22 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 22 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      The fire icon indicates that the profile is currently trending, showing creators who are gaining
                      attention and popularity on the platform.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 23 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(23)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What do gold tiles mean?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 23 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 23 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Gold tiles mark profiles currently featured on the Discover page. The platform’s algorithm
                      selects creators based on specific criteria, regularly updating to showcase fresh talent and keep
                      the featured profiles dynamic.
                    </p>
                  </div>
                </div>
              </div>


            </div>



            <div className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Subscribing, Following & Tips</h2>
                </div>
              </div>
            </div>

            <div className="modern-faq-accordion">

              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 24 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(24)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why subscribe or follow a creator?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 24 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 24 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Subscribing or following a creator gives you access to features like private messaging, voice calls,
                      video calls, and exclusive content. It also keeps you updated on their latest posts (both free and

                      paid) that appear directly in your feed. Juicy House continually introduces new features to en-
                      rich your experience and strengthen your connection with your favorite creators.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 25 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(25)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do you handle regional pricing?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 25 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 25 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Regional pricing is automatically calculated by our system. If a creator charges $9.99 USD for
                      content or a subscription the equivalent amount will be displayed in your local currency. Please

                      note that all transactions are processed in USD and any additional fees related to currency con-
                      version are determined by your financial institution. Juicy House has no control over these

                      charges.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 26 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(26)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Do I have to pay VAT?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 26 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 26 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If you’re in a country where VAT applies, the local rate will be automatically calculated and

                      added to each transaction. This ensures compliance with international tax regulations and al-
                      lows us to remit the correct VAT to the appropriate tax authority.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 27 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(27)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I subscribed to a content creator or purchased content. Why is the content not unlocking?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 27 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 27 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If you've purchased content from a creator but it still shows as locked, try refreshing the web-
                      page. This should resolve the issue and grant you access to the content.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 28 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(28)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Where can I find the accounts I am currently subscribed to?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 28 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 28 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Once logged in, click the home button on your menu bar. From here, you can navigate between
                      separate tabs to view your feed, manage your subscriptions, and access any purchased content.

                      You can also see which subscriptions are expiring soon or have already expired, keeping you ful-
                      ly up to date.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 29 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(29)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How often am I charged?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 29 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 29 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      For subscription accounts, you will be billed monthly until you choose to cancel or unsubscribe
                      from a creator’s account. Tips and individual content purchases are one time charges, applied
                      each time you tip or buy content. The charge will reflect the amount you tipped or the price of
                      the content purchased.
                    </p>

                    <p className="modern-faq-answer-text">
                      <b>Note:</b> Once your free trial or monthly discount expires, you will need to manually resubscribe to
                      the creator’s profile to continue accessing exclusive features and posts.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 30 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(30)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How does auto-renewal subscriptions work?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 30 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 30 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Subscriptions are set to auto renew by default unless you subscribed to a creator running a
                      promotion such as a discounted monthly price or a free trial. Once the promotion ends you will
                      need to manually re-subscribe to continue messaging, calling, or accessing exclusive content.
                    </p>


                    <ul>
                      <li>
                        If your credit card declines, you will lose access to the creator’s profile when your current
                        subscription period ends.
                      </li>

                      <li>
                        If a creator changes their subscription price, you will continue to be charged the original
                        price you subscribed at. For example, if you subscribed to a creator for $9.99 and they later
                        raise their price to $19.99, you will continue paying $9.99 until you choose to unsubscribe.
                      </li>
                    </ul>

                    <p className="modern-faq-answer-text">
                      If you lose access to a creator, please review your account and make sure you have a valid credit
                      card added then try to subscribe again.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 31 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(31)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I get charged?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 31 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 31 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      All credit card charges are processed in USD. We use CCBill, a secure and encrypted third-party
                      payment processor to handle all transactions. Your credit card information is never stored on
                      our platform and is not accessible to any of our employees.
                    </p>

                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 32 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(32)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I subscribe to a content creator?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 32 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 32 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>Create a subscriber account by going to the signup page and selecting the appropriate option.</li>
                      <li>Go to the creator’s profile and click “Follow” or “Subscribe.”</li>
                      <li>Pay-per-view (PPV) accounts can be followed for free and do not require a credit card until you make your first purchase, tip, or buy credits for a call.</li>
                      <li>PPV charges are non-recurring and you will only be charged for each individual purchase or transactions you initiate.</li>
                      <li>Following a creator PPV account instantly unlocks the ability to message or call them and adds their past and new posts to your feed. You can view their free content or purchase locked content by tapping “Home” in the menu bar or visiting the creator’s profile directly.</li>
                      <li>For monthly subscription accounts, you will need to provide a credit card if one is not already on file to activate and maintain your subscription.</li>
                      <li>Subscribing instantly unlocks all of a creator’s content, including past and new posts, plus the ability to message or call them. You can view the creators content you recently subscribed to in your feed by tapping “Home” in the menu bar or directly on the creator’s profile. Subscriptions last for one calendar month (30 days) from the purchase date.</li>
                      <li>If you know a creator’s username, you can search for them on the Discover page by tapping the magnifying glass and entering their username (e.g., @juicyhouse). You can also browse creators by category to find an account that matches your interests.</li>
                    </ul>

                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 33 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(33)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Chargebacks / Credit Card Disputes</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 33 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 33 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If a user requests a chargeback or disputes a transaction with their credit card company, their
                      access to Juicy House may be suspended or limited. If you believe your account has been restricted in error, please contact support at <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a>.
                    </p>
                    <p className="modern-faq-answer-text">Any amounts that are refunded or charged back will be reported to the content creator and deducted from their earnings.</p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 34 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(34)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Refunds</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 34 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 34 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Purchases are reviewed on a case by case basis. You can unsubscribe from an account at any
                      time for any reason to stop future subscription charges. If you send a priority message and do
                      not receive a response within 10 days, the amount tipped will be automatically refunded. You
                      can track refunds by going to your Menu and selecting Transactions.
                    </p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 35 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(35)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What type of credit cards are accepted?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 35 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 35 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">We accept Visa, MasterCard, JCB, Diners Club, Discover, and Maestro.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 36 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(36)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What information will be displayed on my card statement?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 36 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 36 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Charges will appear on your card statement as “CCBill.com Prestige Int.”</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 37 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(37)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What should I do if I can’t subscribe?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 37 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 37 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Make sure you have a valid credit card on file, have verified your email address, and are using an up to date browser such as Safari, Chrome, or Firefox.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 38 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(38)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I cancel a subscription?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 38 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 38 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>Tap “Home” and go to the Subscriptions section to view all creators you follow or are subscribed to. You can filter to show subscriptions only by selecting the appropriate tab.</li>
                      <li>You must be logged in to unsubscribe from a profile.</li>
                    </ul>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 39 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(39)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I get into a creator’s Priority inbox?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 39 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 39 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">There are two ways to become a Priority user:</p>
                    <ul>
                      <li>Send a tip with your first message. Once the creator responds, you will be categorized as Priority.</li>
                      <li>Reach the required spend threshold with the creator within 60 days.</li>
                    </ul>

                    <p className="modern-faq-answer-text">If you have no spending activity with a creator for 60 days, you will be moved back to their standard messaging inbox. You must meet the required spend threshold again to return to a creators Priority inbox. Tap the question mark icon at the top of your Messaging inbox for more details.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 40 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(40)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do free trials or discounts work on Juicy House?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 40 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 40 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Creators can offer two discount options:</p>
                    <ul>
                      <li><b>Free trial subscriptions:</b> Creators may offer new or expired subscribers a free trial sub-
                        scription. These trials do not auto-renew, but you can choose to continue your subscrip-
                        tion at the full subscription price once the trial ends.</li>
                      <li><b>Discounted subscriptions:</b> Creators can offer a discount on their usual subscription price

                        for a set period. Once the promotional period has ended, subscribers must manually re-
                        new their subscription at the full subscription price.</li>
                    </ul>

                    <p className="modern-faq-answer-text">To update your subscription price, you must first cancel your current campaign or wait for it to
                      end before setting a new price.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 41 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(41)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I did not like the page I subscribed to. Can I get a refund?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 41 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 41 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">All purchases made on Juicy House are reviewed on a case by case basis and are not automat-
                      cally refundable. You may unsubscribe at any time for any reason to prevent future charges, but

                      unsubscribing does not provide a refund for the current subscription period. Please note that
                      repeated or abusive refund requests may result in your account being suspended or deleted.</p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 42 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(42)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Tipped incorrect amount</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 42 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 42 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Tips are voluntary contributions to support creators and cannot be refunded once processed. If
                      you believe you’ve tipped an incorrect amount, please contact our support team at
                      <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a> with the email registered to your account for further assistance.</p>

                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 43 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(43)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Tips are not working</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 43 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 43 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">If your tip failed to process, it may be due to one of the following reasons:</p>
                    <ul>
                      <li>Incorrect credit card details entered</li>
                      <li>Insufficient funds in your account</li>
                      <li>Incorrect billing address, zip code, or postal code</li>
                      <li>Your bank or credit card provider has a limit on internet transactions. We cannot provide details if your bank is blocking the purchase, so please contact your card issuer directly</li>
                      <li>Using a proxy or VPN while accessing Juicy House may trigger your bank’s IP verification system, which can restrict purchases. If this occurs, please reach out to your bank to determine why your card was declined</li>
                    </ul>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 44 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(44)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Maximum Tips</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 44 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 44 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">You may only tip a maximum of $100 at a time for a single transaction.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 45 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(45)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What if I tip creator for content but never receive the content?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 45 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 45 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Unfortunately, we cannot issue refunds for private messages or tips as these are voluntary contributions to support creators. Juicy House is a social platform where creators independently manage their content and we cannot guarantee specific actions or influence their content decisions. If you have concerns, please try to contact the content creator directly with regard to this issue.</p>
                  </div>
                </div>
              </div>




            </div>





            <div className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Messaging, Discovery & Notifications</h2>
                </div>
              </div>
            </div>

            <div className="modern-faq-accordion">

              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 46 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(46)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a subscriber signing up — what happens when I select interest?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 46 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 46 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Interest tabs customize your Discovery page by aligning with your preferences, making it easy to
                      find and connect with creators that align with your interests.</p>
                    <p className="modern-faq-answer-text">If you skip selecting interests during signup, no problem, your Discovery page will adapt over
                      time based on your activity such as tipping, subscribing, or purchasing content. It will continue
                      to refine as you engage with creators you enjoy.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 47 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(47)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a subscriber — What does the message icon mean on content tiles in my feed?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 47 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 47 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">When you go to your feed (tap the Home icon on your navigation bar), you will see content from
                      creators you follow or are subscribed to. The message icon on a content tile opens an exclusive
                      1-on-1 chat with that creator, where you can send messages, receive content, or request calls.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 48 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(48)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a creator signing up — why do I have to choose a profile tag?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 48 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 48 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">By using relevant tags that align with your content and profile, you can connect with a more tar-
                      geted audience interested in your niche. These tags increase your visibility, making your profile

                      more likely to appear on the Discovery page or in the Recommended section of subscribers who
                      engage with similar creators or content, boosting engagement and attracting fans who resonate
                      with your work.</p>
                    <p className="modern-faq-answer-text">You can update your tags anytime by going to the menu and selecting “Tags.”</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 49 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(49)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a creator — what does unread priority mean?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 49 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 49 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Unread priority messages are initial messages from subscribers that include a tip but haven’t
                      been responded to yet. In this section, you can view the subscriber’s username, their message,
                      the tip amount, and the time remaining to reply. You will receive the tip only after responding to
                      the subscriber.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 50 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(50)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a creator — what happens if I don’t respond to a priority message?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 50 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 50 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">If you don’t respond to a priority message within 10 days the subscriber will automatically receive a refund and you will not receive the tipped amount. You will only receive the tip once you
                      reply to the subscriber’s initial message within the active timeframe.</p>
                    <p className="modern-faq-answer-text">Both you and the subscriber will receive a reminder notification when 5 days remain to respond.
                      This notification appears under your Activity tab.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 51 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(51)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a creator — what does the whale emoji next to a subscriber username mean?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 51 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 51 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">A whale emoji beside a subscribers username means the user spent $500 or more within 60
                      days.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 52 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(52)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What happens when I respond to a subscriber?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 52 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 52 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Once you reply to a subscriber, the tipped amount is added to your Juicy House wallet and the
                      chat will be moved to your Priority Messages.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 53 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(53)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What happens when I respond to a subscriber but they stop spending?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 53 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 53 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">If a subscriber has not sent tips or made purchases within 60 days their chat will be moved from
                      your Priority Messages inbox to your general Messages inbox, which includes messages from
                      non-spending users. To have their chat return to the Priority Messages inbox the subscriber
                      must spend at least $100 within a 60 day period. Chats are automatically filtered based on
                      spending activity to prioritize your most active users.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 54 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(54)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How can I adjust my video and voice call pricing?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 54 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 54 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      You can easily set or update your call pricing by tapping the call icons in a chat or navigating to
                      Edit Profile. You can choose to charge per minute or offer bulk rates for specific time durations.
                    </p>
                    <p className="modern-faq-answer-text">
                      You can also set a minimum call duration to ensure subscribers meet your requirements before
                      initiating a call. If a minimum call time is set, users must meet those requirements to start a call
                      with you.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 55 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(55)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I start a call?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 55 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 55 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Open the chat with the creator or subscriber and tap the icon for the type of call you want to

                      start, video or voice. Subscribers requesting a call will see a full pricing breakdown before sending the request. Similarly, if a creator sends a call request, subscribers will see the pricing details

                      before accepting.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 56 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(56)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What if a subscriber ends a call early with a minimum call time set?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 56 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 56 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If a subscriber ends a call early, you’ll still receive the full minimum balance set before the call
                      began, ensuring your pricing requirements are met.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 57 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(57)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What if a creator ends a call early with a minimum call time set?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 57 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 57 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If a creator ends a call before the minimum call time is met, the subscriber will only be billed on
                      a per minute basis. The calculation is based on the creators set rate and the minutes used on
                      the call.
                    </p>
                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 58 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(58)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What happens once a call request is sent?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 58 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 58 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      After a call request is sent, you have three minutes to join before it is automatically canceled. If
                      you’re not on the platform when a call comes in, your phone will ring like a regular phone call,
                      making it easy for both the creator and subscriber to be notified of an incoming call.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 59 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(59)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">My chat disappeared</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 59 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 59 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      When a subscription expires or a user unfollows a creator, the chat will be moved from your
                      main inbox to the “Archived” tab. If you are a subscriber that has purchased content, you can
                      view all your purchased content in the “Purchased” tab. Simply tap “Home” on the menu bar
                      and select “Purchased” to access it.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 60 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(60)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What happens when I tip on the first message?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 60 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 60 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">When you include a tip with your first message, you’ll be placed in the creator’s Unread Priority inbox. The creator has 10 days to respond. If they don’t reply within that timeframe, your tip is automatically refunded. Refunds appear in your Transactions tab in the menu.</p>
                    <p className="modern-faq-answer-text">If the creator responds, your chat moves to their Priority inbox and the tip is processed. Messages sent without a tip are delivered to a separate, non-priority inbox.</p>
                    <p className="modern-faq-answer-text">If you stop tipping or purchasing content from a creator for 60 days, your chat will move back to their general Messages inbox. To regain Priority status, you’ll need to meet the required spend threshold again.</p>
                    <p className="modern-faq-answer-text">Tap the question mark icon at the top of your Messaging inbox for more details.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 61 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(61)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a subscriber — what does the Extend button in my notifications mean?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 61 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 61 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      When you message a content creator they have 10 days to respond. When 5 days remain, you

                      can extend the response time by an additional 5 days giving the creator a total of 15 days to reply before you are automatically refunded. Once you initiate an extension the creator will be

                      notified.
                    </p>

                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 62 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(62)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is a priority inbox?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 62 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 62 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Creators have multiple inboxes and the priority inbox is reserved for subscribers or followers
                      who are consistent supporters and have been categorized as such. This separates high-priority
                      messages from standard ones, ensuring that creators can quickly see and respond to those that

                      are most engaged. If your message is moved to a creator’s Priority inbox, you will see it reflected in your own inbox under the Priority tab.
                    </p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 63 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(63)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I get into a creator’s Priority inbox?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 63 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 63 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">There are two ways to become a priority user:</p>

                    <ul>
                      <li> Send a tip with your first message. Once the creator responds, you will be categorized as Priority.</li>
                      <li>Reach the required spend threshold with the creator within 60 days.</li>
                    </ul>

                    <p className="modern-faq-answer-text">If you have no spending activity with a creator for 60 days, you will be moved back to their standard messaging inbox. You must meet the required spend threshold again to return to a creators Priority inbox. Tap the question mark icon at the top of your Messaging inbox for more details.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 64 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(64)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Finding a profile</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 64 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 64 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">There are three search functionalities available.</p>

                    <ul>
                      <li><b>Home:</b> Profiles you follow, subscribe to, or have purchased content from will appear under the Home tab on your menu bar.</li>
                      <li><b>Username or Keyword Search:</b> Go to the Discover page and tap the magnifying glass in
                        the top-right corner. You can search by username (e.g., @juicyhouse) or enter keywords
                        like creampie, fetish, anal, big tits, and more to find creators and content that match
                        your interests.</li>
                      <li>Categories: Go to the discover page and browse all categories to find creators that
                        match your interests.</li>
                    </ul>


                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 65 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(65)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What are all the tags I can search for to find a content creator?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 65 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 65 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">We currently have over 90 tags that you can search for to locate a content creator profile that fits your preference:</p>
                    <p className="modern-faq-answer-text"><b>Genre/Style</b></p>
                    <ul>
                      <li>Amateur</li>
                      <li>Amateur POV</li>
                      <li>Cosplay</li>
                      <li>Fetish</li>
                      <li>Foot fetish</li>
                      <li>Hardcore</li>
                      <li>Hentai</li>
                      <li>Homemade</li>
                      <li>POV</li>
                      <li>Public sex</li>
                      <li>Softcore</li>
                      <li>Solo</li>
                      <li>Step fantasy</li>
                      <li>Vintage</li>
                      <li>Virtual Reality</li>
                      <li>Voyeur</li>
                    </ul>
                    <p className="modern-faq-answer-text"><b>Body Type/Physical Attributes</b></p>
                    <ul>
                      <li>BBW</li>
                      <li>Big ass</li>
                      <li>Big ass latina</li>
                      <li>Big ass naked</li>
                      <li>Big ass porn</li>
                      <li>Big boobs</li>
                      <li>Big breast</li>
                      <li>Big tits</li>
                      <li>Busty</li>
                      <li>Curvy</li>
                      <li>Dwarf</li>
                      <li>Natural tits</li>
                      <li>Petite</li>
                      <li>Small tits</li>
                      <li>Tatted</li>
                    </ul>
                    <p className="modern-faq-answer-text"><b>Hair/Appearance</b></p>
                    <ul>
                      <li>Blonde</li>
                      <li>Brunette</li>
                      <li>Red head</li>
                      <li>Short hair</li>
                      <li>Hairy</li>
                      <li>Shaved</li>
                      <li>Shaved pussy</li>
                      <li>Smooth</li>
                      <li>Trimmed</li>
                    </ul>
                    <p className="modern-faq-answer-text"><b>Ethnicity/Nationality</b></p>
                    <ul>
                      <li>American</li>
                      <li>Arab</li>
                      <li>Asian</li>
                      <li>Brazilian</li>
                      <li>Ebony</li>
                      <li>Egyptian</li>
                      <li>Filipina</li>
                      <li>Filipino</li>
                      <li>Indian</li>
                      <li>Indigenous</li>
                      <li>Japanese</li>
                      <li>Jav (Japanese Adult Video)</li>
                      <li>Latina</li>
                      <li>Middle Eastern</li>
                      <li>White</li>
                    </ul>
                    <p className="modern-faq-answer-text"><b>Sex Acts/Positions</b></p>
                    <ul>
                      <li>Anal</li>
                      <li>Blow jobs</li>
                      <li>Cock sucking</li>
                      <li>Cowgirl riding</li>
                      <li>Creampie</li>
                      <li>Cum shot</li>
                      <li>Deep throat</li>
                      <li>Deep throat blowjob</li>
                      <li>Dick riding</li>
                      <li>Dick sucking</li>
                      <li>Doggystyle</li>
                      <li>Facial</li>
                      <li>Fingering</li>
                      <li>Fuck pussy</li>
                      <li>Fucking</li>
                      <li>Handjob</li>
                      <li>Hardcore fucking</li>
                      <li>Kissing</li>
                      <li>Missionary</li>
                      <li>Oral sex</li>
                      <li>Pussy licking</li>
                      <li>Rimming</li>
                      <li>Rough fucking</li>
                      <li>Rough sex</li>
                      <li>Sex</li>
                    </ul>

                    <p className="modern-faq-answer-text"><b>Group Dynamics</b></p>
                    <ul>
                      <li>Gangbang</li>
                      <li>Group sex</li>
                      <li>Threesome</li>
                    </ul>

                    <p className="modern-faq-answer-text"><b>Sexual Orientation/Gender</b></p>
                    <ul>
                      <li>Gay</li>
                      <li>Lesbian</li>
                      <li>Shemale</li>
                      <li>Straight</li>
                      <li>Trans</li>
                      <li>Twinks</li>
                    </ul>
                    <p className="modern-faq-answer-text"><b>Age/Experience</b></p>
                    <ul>
                      <li>College</li>
                      <li>Hot milf</li>
                      <li>Mature</li>
                      <li>Milf</li>
                      <li>Teen</li>
                      <li>Young men</li>
                    </ul>

                    <p className="modern-faq-answer-text"><b>Specific Attributes/Preferences</b></p>
                    <ul>
                      <li>Ageplay</li>
                      <li>Average dick</li>
                      <li>Big cock</li>
                      <li>Big cock fuck</li>
                      <li>Big dick</li>
                      <li>Large dick</li>
                      <li>Uncut</li>
                    </ul>
                    <p className="modern-faq-answer-text"><b>Kinks/Fetishes</b></p>
                    <ul>
                      <li>BDSM</li>
                      <li>Cuckold</li>
                      <li>Femdom</li>
                      <li>Leather</li>
                      <li>Pregnant</li>
                      <li>Squirting</li>
                      <li>Toys</li>
                      <li>Vibrator</li>
                    </ul>

                    <p className="modern-faq-answer-text"><b>Performer Type</b></p>
                    <ul>
                      <li>Babe</li>
                      <li>Pornstar</li>
                    </ul>


                    <p className="modern-faq-answer-text"><b>Other</b></p>
                    <ul>
                      <li>Interracial</li>
                      <li>Jacking off</li>
                      <li>Masturbation</li>
                      <li>Nude</li>
                      <li>Pink pussy</li>
                      <li>Pussy</li>
                      <li>Bareback</li>
                    </ul>


                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 66 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(66)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Where is a content creators username located?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 66 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 66 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">A creator’s username appears next to their profile picture if they are featured, or beneath their
                      profile picture on tiles in the Discover page and on individual creator pages.</p>

                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 67 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(67)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a subscriber, where are notifications located?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 67 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 67 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Notifications can be found on the navigation bar at the bottom of your screen under Activity.

                      This section includes all priority messages, new posts, subscriptions, payments & tips, promotions, and archived notifications.
                    </p>
                    <p className="modern-faq-answer-text">
                      Notifications that have already been viewed and are more than 14 days old will automatically
                      move to the Archived tab.
                    </p>

                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 68 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(68)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I’m a creator, where are notifications located?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 68 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 68 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Notifications can be found on the navigation bar at the bottom of your screen under Activity.
                      This section includes all priority messages, sales & tips, payouts, tags, promotions, archived, and
                      depending on your account type, subscriptions and following updates.
                    </p>
                    <p className="modern-faq-answer-text">
                      Notifications that have already been viewed and are more than 14 days old will automatically
                      move to the Archived tab.
                    </p>

                  </div>
                </div>
              </div>

            </div>



            <div className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Posting</h2>
                </div>
              </div>
            </div>

            <div className="modern-faq-accordion">

              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 69 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(69)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What does “Locked" and “Unlocked” content mean?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 69 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 69 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      You can set your content as “Locked” or “Unlocked” at any time, either for pay-per-view (PPV) or
                      subscription accounts.
                    </p>

                    <ul>
                      <li>
                        <b>Unlocked:</b> Content marked as “Unlocked” is visible to all website visitors and subscribers. It is not restricted by a paywall
                      </li>

                      <li><b>Locked:</b> Content marked as “Locked” is hidden behind a paywall and can only be accessed by users who subscribe or purchase the content</li>
                    </ul>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 70 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(70)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Who can see my Juicy House page?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 70 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 70 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Free Content</p>

                    <ul>
                      <li>Content marked as “Unlocked” is visible to all website visitors and subscribers. It is not restricted by a paywall</li>
                    </ul>
                    <p className="modern-faq-answer-text">Paid Content</p>
                    <ul>
                      <li>Content marked as “Locked” is behind a paywall and can only be viewed by users who subscribe or purchase your content</li>
                      <li>Subscribers can access all past and future posts once subscribed</li>
                    </ul>

                    <p className="modern-faq-answer-text"><b>Note:</b> All content must comply with our Terms of Service, or it may be subject to suspension or removal.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 71 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(71)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What happens when I tag another content creator in a post?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 71 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 71 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Tagging another creator in a post lets your audience see everyone featured or mentioned in that
                      post. The tagged creator will receive a notification letting them know they were tagged and your
                      audience can tap their username to visit their profile directly. At this time, creators can’t browse

                      or view other creator profiles but this feature will be available soon as Juicy House expands creator to creator exploration tools.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 72 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(72)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How should I promote my account?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 72 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 72 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      We recommend leveraging your existing social media channels to directly connect with your
                      audience and promote your Juicy House account. Additionally, Juicy House supports creators by

                      driving traffic and engagement through our dedicated marketing channels, increasing your visibility and helping boost your sales.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 73 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(73)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Can I have multiple accounts?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 73 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 73 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Yes! content creators can have up to three accounts, unless they have been banned for violating

                      our Terms of Service. Subscribers can create as many accounts as they wish but will be restricted from signing up if they breach our Terms of Service.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 74 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(74)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How can I delete or edit a post?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 74 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 74 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Yes! After logging into your content creator account go to the post you want to edit or delete,

                      tap the three dots in the lower right corner of the content tile, and select the appropriate option.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 75 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(75)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How can I see how much I got tipped?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 75 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 75 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>The number next to the heart icon on your content tiles shows the number of tips received, not the dollar amount</li>
                      <li>The money bag icon on a tile displays the total dollar amount you earned in tips for that specific post</li>
                      <li>The money bag at the top of your profile (above Feed, Media, and Free) shows your total tips received across all posts</li>
                      <li>You can view your total tips by day, month, or all time by going to the Earnings & Payout tab in the menu</li>

                    </ul>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 76 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(76)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do you deal with stolen content?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 76 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 76 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Juicy House takes content privacy very seriously. We have a dedicated DMCA team that issues
                      formal takedown notices for all reported copyright violations, free of charge for our creators.
                      Our team targets infringing websites, hosting services, and domain registrars, and also notifies
                      major search engines of these violations.</p>
                    <p className="modern-faq-answer-text">To file a DMCA notice, go to the Complaints tab in the menu and fill out the required information on the form.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 77 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(77)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How much can I charge per post or for a subscription?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 77 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 77 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">You can set your subscription price between $6 and $300 per month or for an individual post.
                      This range may be increased or decreased at any time without notice.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Earnings & Payouts */}
            <div id="earnings-payouts" className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Earnings & Payouts</h2>
                </div>
              </div>
            </div>
            <div className="modern-faq-accordion">
              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 78 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(78)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do I start earning on Juicy House?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 78 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 78 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      To start earning on Juicy House, follow these steps:
                    </p>

                    <ul>
                      <li>Select “Become a Housemate” on the signup screen when choosing your account type</li>
                      <li>Choose your profile type, either pay-per-view (PPV) or monthly subscription</li>
                      <li>Submit your ID or passport for verification, once approved, you will receive a verification email and gain full access to your content creator profile</li>
                      <li>Set your subscription price if you chose a subscription profile, the default price is $6 per month but you can change this at any time.</li>
                      <li>Start posting! Once your account is active, you can begin uploading content immediately and start earning</li>
                    </ul>

                    <p className="modern-faq-answer-text">
                      <b>Note:</b> Free accounts are not available. Content marked as “Unlocked” is visible to all website
                      visitors and subscribers without a paywall. Only “Locked” content is restricted and requires a
                      subscription or to be purchase. You can switch your content between “Locked” and “Unlocked”
                      at any time even after posting the content.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 79 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(79)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Creator payout percentage</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 79 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 79 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Content creators receive 100% of their earnings from subscriptions, tips, calls, and content purchases.</p>
                  </div>
                </div>
              </div>

              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 99 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(99)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What countries do you payout to? </span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 99 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 99 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Juicy House delivers payouts to every country worldwide via ACH bank transfers or cryptocurrency, providing fast, secure, and fully compliant borderless payments.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 100 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(100)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Which cryptocurrencies are available for payouts?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 100 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 100 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">We facilitate payouts through four leading blockchain networks:</p>

                    <ul>
                      <li>Ethereum Network (ERC20)</li>
                      <li>Tron Network (TRC20)</li>
                      <li>Litecoin Network (LTC)</li>
                      <li>Solana Network (SOL)</li>
                    </ul>

                    <p className="modern-faq-answer-text">Using these networks, you can choose to receive your funds in the following cryptocurrencies. Some options may be limited depending on the chosen network:</p>

                    <ul>
                      <li>Ethereum (ETH)</li>
                      <li>Tether (USDT)</li>
                      <li>USD Coin (USDC) </li>
                      <li>Litecoin (LTC)</li>
                      <li>Solana Network (SOL)</li>
                    </ul>

                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 80 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(80)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why do I see a flat fee deduction?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 80 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 80 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      A flat $15 fee applies to cash-outs over $100 to cover ACH bank and cryptocurrency transfer

                      costs. This fee is fixed and will never change or fluctuate. All transactions and payouts are processed in USD. If you notice any additional fees for currency conversion, these are charged by

                      your financial institution which Juicy House has no control over.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 81 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(81)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why was my payout request was rejected?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 81 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 81 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">Your payout request may be rejected for several reasons:</p>
                    <ul>
                      <li>Your previously submitted ID has expired</li>
                      <li>The documents you submitted do not meet the requirements to process your payout</li>
                      <li>Your account is missing payout information, preventing withdrawals</li>
                      <li>The information on your 1099 form does not match your ID or passport</li>
                      <li>You have earned more than $599 and have not completed your 1099 tax form. You cannot cash out until this form is submitted</li>
                    </ul>

                    <p className="modern-faq-answer-text">If you are having trouble cashing out, please contact <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a>. Once your new ID or passport has been re-verified, you will be able to continue withdrawing your earnings.</p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 82 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(82)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Payouts</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 82 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 82 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>
                        Payouts must be manually initiated, to do this, tap Menu on the navigation bar at the
                        bottom of your screen, select Earnings & Payouts, and then tap Request Payout
                      </li>
                      <li>
                        Your pending balance becomes available every two weeks and is tracked per transaction,
                        for example, a transaction on the 1st will be available on the 15th and so on
                      </li>
                      <li>
                        You can withdraw your earnings via bank ACH or cryptocurrency
                      </li>
                      <li>
                        Withdrawals are typically processed same day, unless it falls on a holiday, which may
                        cause a delay
                      </li>
                      <li>
                        In the event of a successful chargeback or refund, the amount will be deducted from
                        your reserved funds
                      </li>
                    </ul>

                    <p className="modern-faq-answer-text">
                      <b>Note:</b> If a user successfully requests a refund or initiates a chargeback, the amount will be deducted from your reserved funds and reflected as an adjustment in your statements. You can

                      view a detailed breakdown of your earnings under the daily or monthly statements. If your reserved funds are insufficient to cover the refund or chargeback, the remaining balance will be

                      deducted from your pending balance. Each chargeback also incurs an additional $20 fee.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 83 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(83)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why can’t I cash out my earnings yet?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 83 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 83 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">There may be several reasons you cannot cash out your earnings including:</p>
                    <ul>
                      <li>You must earn at least $30 to be eligible for a payout</li>
                      <li>Your balance may not have fully processed from pending to available yet</li>
                      <li>Pending balances are released every two weeks and tracked per transaction, for example, a transaction made on the 1st will become available on the 15th, and so on</li>

                    </ul>


                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 84 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(84)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why is my payment delayed?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 84 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 84 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Payments may be delayed due to holidays affecting bank hours or issues with the payment
                      provider, which are outside of Juicy House’s control. If it has been more than 10 days since your
                      payment was marked as processed, please email <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a> and include a copy
                      of your bank statement.
                    </p>


                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 85 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(85)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why are there funds showing as reserved on my Earnings & Payouts?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 85 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 85 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      To protect both creators and the platform, Juicy House holds 5% of all earnings in a 30-day
                      rolling reserve. This reserve is used to cover any chargebacks or refunds that may occur.
                    </p>
                    <p className="modern-faq-answer-text">
                      Funds are added to the reserve as you earn, and any chargebacks or refunds during that period
                      are automatically deducted from it. For example, 5% of earnings from a transaction on the 1st
                      will be released and added to your available balance on the 30th.
                    </p>

                    <ul>
                      <li>
                        <b>Chargebacks:</b> The total chargeback amount plus a $20 fee will be deducted from your
                        reserved funds. This deduction appears on both your daily and monthly statements. If
                        the reserve does not cover the full amount, the remaining balance will be deducted
                        from your pending funds.
                      </li>
                      <li>
                        <b>Refunds:</b> Only the refunded amount is deducted from your reserved funds.
                      </li>
                    </ul>

                    <p className="modern-faq-answer-text">We take steps to minimize chargebacks and refunds to protect your earnings. Refunds are never
                      guaranteed, and all transactions are evaluated on a case by case basis.</p>


                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 86 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(86)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How much of the payout do I receive?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 86 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 86 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Creators receive 100% of their earnings from subscriptions, content, calls, and tips. Your pending and available balances are shown in USD. A flat $15 fee applies to cash-outs over $100 to

                      cover ACH bank and cryptocurrency transfer costs.
                    </p>
                    <p className="modern-faq-answer-text">
                      Note: Payouts are sent in USD and will be converted to your account’s local currency by your
                      bank. Your financial institution may charge fees for currency conversion which is outside of Juicy
                      House’s control.
                    </p>




                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 87 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(87)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is the minimum withdrawal amount?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 87 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 87 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">A minimum balance of $30 is required for content creators to withdraw their earnings.</p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 88 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(88)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">My payout has been processed. Where is it?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 88 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 88 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      After initiating a payout please allow at least 24 hours for the transfer to complete. Bank holidays may cause additional delays. If your payout has been processed and you haven’t received

                      your funds within 7 days, contact <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a>.
                    </p>
                    <p className="modern-faq-answer-text">
                      For cash outs processed in cryptocurrency, please ensure you enter the correct wallet address.

                      You are responsible for verifying the wallet address you enter. Funds sent to an incorrect ad-
                      dress cannot be recovered and Juicy House is unable to retrieve them.
                    </p>
                  </div>
                </div>
              </div>




              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 89 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(89)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What should I do if users say they can’t subscribe or send tips?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 89 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 89 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      If subscribers are having trouble, advise them to contact our support team at <a href='mailto: support@juicyhouse.com'>support@juicyhouse.com</a> as the issue may be specific to their account.
                    </p>
                  </div>
                </div>
              </div>




            </div>





            <div className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Referrals</h2>
                </div>
              </div>
            </div>

            <div className="modern-faq-accordion">

              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 90 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(90)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Referral program</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 90 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 90 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Juicy House offers a lifetime referral payout of 5% of the platform’s earnings from any creator

                      you refer. There are no limits to the number of creators you can refer or the total referral earnings you can earn.
                    </p>
                    <p className="modern-faq-answer-text">
                      <b>Note:</b> If someone signs up without using your referral code, we cannot link that account to your

                      referral. The system is fully automated and cannot be changed. For more details, see the Referral Program Terms in the Legal section of our website.
                    </p>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 91 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(91)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Referral link</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 91 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 91 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>
                        Tap the Referrals tab located in the menu on the navigation bar at the bottom to find
                        your unique referral URL
                      </li>
                      <li>Share your referral link with anyone you think would make a great Juicy House creator</li>
                      <li>To earn referral income, the creator must sign up using your unique link</li>
                      <li>Creators cannot use their own referral link</li>
                    </ul>
                    <p className="modern-faq-answer-text">
                      <b>Note:</b>Referral links can only be used by individuals who do not currently have or have previously had a Juicy House account. Deleting an old account and signing up with a referral link is not

                      allowed.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 92 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(92)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Referral income</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 92 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 92 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <ul>
                      <li>
                        Referral income is tracked per transaction and becomes available every two weeks, for
                        example, earnings from a transaction on the 1st will be available on the 15th and so on
                      </li>
                      <li>Referral income is credited directly to your Juicy House account, you are responsible for
                        manually cashing out your earnings either via bank ACH or cryptocurrency</li>
                      <li>
                        If your monthly referral income does not meet the minimum $30 withdrawal requirement, it will roll over until you are eligible to cash out
                      </li>
                    </ul>

                  </div>
                </div>
              </div>


            </div>




            <div className="modern-faq-header-card mt-5">
              <div className="modern-faq-header-content-card">
                <div className="modern-faq-header-left">
                  <h2 className="modern-faq-section-title">Tax Information</h2>
                </div>
              </div>
            </div>

            <div className="modern-faq-accordion">

              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 99 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(99)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Do U.S. based creators need to fill out a W-9 form?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 99 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 99 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      You only need to fill out a W-9 form if you are a U.S. person (citizen or resident) and have earned $599 or more on Juicy House. Once your earnings reach this amount, withdrawals will be temporarily restricted until you complete the W-9 form. This form provides the information we need to report your earnings to the IRS using a 1099-NEC at the end of the year.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 100 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(100)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is a W-9 form?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 100 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 100 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      A W-9 form is an IRS form used by U.S. individuals and businesses to provide their taxpayer identification information. This includes your name, address, and Social Security Number or Employer Identification Number. Juicy House uses this information to report your earnings to the IRS and ensure proper tax compliance.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 93 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(93)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is a 1099 form / Do I need a 1099 form?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 93 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 93 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      All U.S. creators who earn $599 or more within a calendar year will receive a 1099-NEC form.
                      Copies of these forms are filed with the IRS and mailed to the address on file for the creator.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 94 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(94)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">I need a W2 / W4</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 94 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 94 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      The tax form required for your earnings on Juicy House is a 1099 NEC Form.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 95 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(95)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">The information shown on the 1099 is incorrect</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 95 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 95 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Please submit a support request from the help center portal and we will investigate with our tax
                      team and keep you updated as soon as the issue is resolved.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 96 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(96)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is VAT?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 96 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 96 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Value Added Tax (VAT) is a consumption tax that's added to the price of goods and services. It's
                      collected at each stage of the supply chain where value is added.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 97 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(97)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">How do you handle VAT?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 97 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 97 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      We act as the merchant of record (MoR) for all transactions on our platform, which means we
                      manage VAT calculations and payments for you.
                    </p>
                    <p className="modern-faq-answer-text">
                      Here's how it works:
                    </p>

                    <ul>
                      <li>
                        We calculate the correct VAT (or local sales tax) at checkout based on the buyers country
                        and the final price buyers see already includes any applicable tax
                      </li>
                      <li>
                        If you're VAT registered and have added your VAT number your daily and monthly earning reports will display your VAT/GST number along with the VAT amount remitted on

                        your behalf
                      </li>
                      <li>
                        Once you add your VAT number you can declare the VAT remitted as output tax and depending on your local regulations you may be able to offset it against input tax on eligible business expenses
                      </li>
                      <li>
                        For any sales made while your VAT number was missing "VAT not applicable" will be displayed on your earning reports and you will responsible for reviewing your transaction

                        history, calculating the VAT that should have been applied, and including it in your next
                        VAT return
                      </li>
                    </ul>
                  </div>
                </div>
              </div>



              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 98 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(98)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Do you remit the VAT on behalf of creators for every transaction?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 98 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 98 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Yes! Once you submit your VAT number to Juicy House we handle VAT on your behalf. It's automatically calculated, collected from the buyer, and remitted directly to your local tax authority

                      so there is nothing you need to manage or submit yourself.
                    </p>
                    <p className="modern-faq-answer-text">
                      <b>Note:</b> VAT rates and regulations may change. We automatically update our system to reflect
                      current rates and ensure compliance.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 101 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(101)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Do creators outside the U.S. need to complete a W-8BEN form?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 101 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 101 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Yes! If you are located outside of the United States you must complete a W-8BEN form before making your first withdrawal. This form must be updated every three years and you will be automatically prompted to do so from the date you initially submitted it. This form provides the information we need to report your earnings to the IRS using a 1042-S at the end of the year.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 102 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(102)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is a W-8BEN form?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 102 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 102 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      A W-8BEN form is a U.S. tax form used by individuals who are not U.S. citizens or residents to certify their foreign status. It helps determine the correct amount of U.S. tax withholding on earnings and allows you to claim any applicable tax treaty benefits. This form is required to receive payouts and must be kept up to date.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 103 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(103)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Do you provide a 1042-S form at the end of the year?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 103 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 103 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Yes! If applicable, a 1042-S form will be issued at the end of the year and made available to you for tax reporting purposes.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 104 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(104)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">What is a 1042-S form?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 104 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 104 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      A 1042-S form is a U.S. tax document that reports income earned in the United States by individuals who are not U.S. citizens or residents. It outlines the total earnings paid to you and any U.S. taxes that were withheld during the year. If applicable, this form is issued annually and can be used when filing taxes in your country of residence.
                    </p>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 105 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(105)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Is Juicy House VAT registered?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 105 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 105 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      Yes! Juicy House is VAT registered under our parent company Prestige International LLC. Our VAT numbers are:
                    </p>
                    <ul>
                      <li>European Union: EU372089114</li>
                      <li>United Kingdom: GB508120234</li>
                    </ul>
                  </div>
                </div>
              </div>


              <div className="modern-faq-item">
                <button className={`modern-faq-question-btn ${openFaq === 106 ? 'modern-faq-question-btn-active' : ''}`} onClick={() => toggleFaq(106)}>
                  <div className="modern-faq-question-content">
                    <span className="modern-faq-question-text">Why does Juicy House have two VAT numbers?</span>
                  </div>
                  <i className={`fa-solid fa-chevron-down modern-faq-chevron ${openFaq === 106 ? 'modern-faq-chevron-active' : ''}`}></i>
                </button>
                <div className={`modern-faq-answer ${openFaq === 106 ? 'modern-faq-answer-active' : ''}`}>
                  <div className="modern-faq-answer-content">
                    <p className="modern-faq-answer-text">
                      We have two VAT numbers, one for the EU and one for the UK, because each region has its own VAT rules. This ensures we comply with local tax laws and rates.
                    </p>
                  </div>
                </div>
              </div>


            </div>



            {/* Support Info */}
            <div className="modern-faq-support-info">
              <div className="modern-faq-support-content">
                <div className="modern-faq-support-item">
                  <i className="fa-solid fa-info-circle modern-faq-support-icon"></i>
                  <span className="modern-faq-support-text">
                    Still have questions? Contact our support team at{' '}
                    <a
                      href={`mailto:${CONFIG.SUPPORT_EMAIL}?subject=Contact%20Support`}
                      className="modern-faq-support-email"
                    > {''}
                      {CONFIG.SUPPORT_EMAIL}
                    </a>
                  </span>

                </div>

              </div>

              <div className='modern-login-divider mt-4'></div>

              <div className="modern-login-copyright" style={{ textAlign: 'center' }}>
                © {new Date().getFullYear()} Prestige International, LLC. All rights reserved.
              </div>
              <div className="modern-login-copyright" style={{ textAlign: 'center' }}>
                Juicy House®
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default withRouter(ModernFAQ); 